import { createRoute } from '@/utils/routing'

export const COUNTRY_GROUP_LIST_ROUTE = 'country-groups-index-categoryId'

export function createCountryGroupListRoute (categoryId, options = {}) {
  if (categoryId != null) {
    return createRoute(COUNTRY_GROUP_LIST_ROUTE, {
      params: { ...options.params, categoryId },
      query: options.query
    })
  }
}
